import React, { useState } from 'react'
import { withRouter } from 'react-router-dom'
import { makeStyles } from '@material-ui/styles'
import { useDispatch, useSelector } from 'react-redux'
import { Input, Button, Picker } from '../root/components/common'
import { enqueueSnackbar } from '../root/actions'
import { Fade } from '@material-ui/core'
import DoneIcon from '@material-ui/icons/Done'
import * as actions from '../root/actions'
import { LOCALE_DISPLAY_OPTIONS } from '../root/constants'
import { PasswordInput } from '../root/components/common/password-input/password-input'
import { usePasswordValidate } from '../root/components/common/password-input/use-password-validate'
import { useBooleanState } from 'web/src/utils/hooks/useBooleanState'
import { useRef } from 'react'

const useStyles = makeStyles(theme => ({
    wrapper: {
        width: '100%',
        height: '100%',
        backgroundColor: theme.background,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'relative'
    },
    formWrapper: {
        width: 600,
        '@media (max-width: 767px)': {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            width: '90%'
        },
        '@media (max-width: 320px)': {
            width: '100%'
        }
    },
    loginLogo: {
        backgroundImage: `url("${theme.loginLogo}")`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center center',
        backgroundSize: 'cover',
        width: 600,
        height: 200,
        marginBottom: 15,
        '@media (max-width: 767px)': {
            width: '90%'
        },
        '@media (max-width: 320px)': {
            width: '100%'
        }
    },
    input: {
        marginBottom: 15
    },
    actionWrapper: {
        display: 'flex',
        justifyContent: 'center',
        marginBottom: 15
    },
    link: {
        fontWeight: 'bold',
        color: theme.primary,
        cursor: 'pointer'
    },
    relative: {
        position: 'relative',
        '@media (max-width: 767px)': {
            width: '100%'
        }
    },
    doneIcon: {
        position: 'absolute',
        color: theme.active,
        top: 10,
        right: -35
    },
    langPickerWrapper: {
        position: 'absolute',
        top: 20,
        right: 20
    }
}))

function ResetPassword(props) {
    const classes = useStyles()
    const dispatch = useDispatch()

    const { locale, localeCode } = useSelector(state => state.main)
    const pristine = useBooleanState(true)
    const [password, setPassword] = useState('')
    const [passwordProof, setPasswordProof] = useState('')
    const [isResetActionActive, setIsResetButtonActive] = useState(true)
    const { validators, isPasswordValid } = usePasswordValidate(password)
    const passwordRef = useRef()

    const arePasswordsEqual = (p, pProof) => {
        return p.length > 0 && pProof.length > 0 && p === pProof
    }

    const isValid = (p, pProof) => {
        let ok = true
        if (!arePasswordsEqual(p, pProof)) {
            ok = false
            dispatch(
                enqueueSnackbar({
                    message: locale.resetPassword.passwordsDoNotMatch,
                    options: {
                        variant: 'warning'
                    }
                })
            )
        }
        if (!isPasswordValid) {
            ok = false
            pristine.off()
            passwordRef.current.focus()
        }
        return ok
    }

    const resetPassword = (p, pProof) => {
        if (!isResetActionActive) return
        if (isValid(p, pProof)) {
            const searchStr = props.location.search
            const queryParams = new URLSearchParams(searchStr)
            const token = queryParams.get('t')
            dispatch(actions.resetPasswordRequest(token, p))
            setIsResetButtonActive(false)
        }
    }

    const onLanguageSelect = localeCode => {
        dispatch(actions.setLocale(localeCode))
    }

    const goToLogin = () => {
        props.history.push('/login')
    }

    return (
        <div className={classes.wrapper}>
            <div className={classes.langPickerWrapper}>
                <Picker
                    onChange={onLanguageSelect}
                    value={localeCode}
                    options={LOCALE_DISPLAY_OPTIONS}
                />
            </div>
            <Fade in={true} timeout={500}>
                <div className={classes.formWrapper}>
                    <div className={classes.loginLogo}></div>
                    <div className={classes.relative}>
                        <PasswordInput
                            inputRef={passwordRef}
                            isError={!pristine.is && !isPasswordValid}
                            validators={validators}
                            className={classes.input}
                            label={locale.common.newPassword}
                            type="password"
                            setValue={setPassword}
                            onEnter={resetPassword.bind(
                                this,
                                password,
                                passwordProof
                            )}
                            value={password}
                        />
                    </div>
                    <div className={classes.relative}>
                        <Input
                            className={classes.input}
                            label={locale.common.newPasswordConfiramtion}
                            type="password"
                            setValue={setPasswordProof}
                            onEnter={resetPassword.bind(
                                this,
                                password,
                                passwordProof
                            )}
                            value={passwordProof}
                        />
                        <Fade
                            in={arePasswordsEqual(password, passwordProof)}
                            timeout={500}
                        >
                            <DoneIcon className={classes.doneIcon} />
                        </Fade>
                    </div>
                    <div className={classes.actionWrapper}>
                        {isResetActionActive && (
                            <Button
                                onClick={resetPassword.bind(
                                    this,
                                    password,
                                    passwordProof
                                )}
                            >
                                {locale.resetPassword.resetPassword}
                            </Button>
                        )}
                        {!isResetActionActive && (
                            <div onClick={goToLogin} className={classes.link}>
                                {locale.resetPassword.goToLogin}
                            </div>
                        )}
                    </div>
                </div>
            </Fade>
        </div>
    )
}

export default withRouter(ResetPassword)
